import { FC } from "react";
import { QesIcon } from "@app/shared/icons/QESIcon";

interface ProjectTagListProps {
  className: string;
  itemClassName: string;
  tags: Record<string, string[]>;
  testId: string;
}

export const ProjectTagList: FC<ProjectTagListProps> = ({ className, itemClassName, tags, testId }) => {
  const entries = Object.entries(tags);
  if (entries.length === 0) {
    return null;
  }

  return (
    <ul className={className} data-testid={testId}>
      {entries.map(([groupName, tagNames]) => (
        <li key={groupName} className={itemClassName}>
          {groupName}
          <QesIcon iconName="Chevron Right Double" isDecorative className="align-text-top mlr5" />
          {tagNames.join(", ")}
        </li>
      ))}
    </ul>
  );
};
